module.exports = __webpack_public_path__ + "img/image-14.5f826961.webp";